export function formatContract(data,memberInfo,petInfo,merchantSetting,storeInfo,installments) {
  const genderText = petInfo.gender === 'female' ? '母' :
                     petInfo.gender === 'male'   ? '公' : '';

  const vaccineText = petInfo.questions.vaccine
    ? `第 ${petInfo.questions.vaccine} 劑`
    : "";

const healthyText = Array.isArray(petInfo.questions.healthy) && petInfo.questions.healthy.length > 0
  ? petInfo.questions.healthy.map(item => item.title).join("、")
  : "";

  const behaviorText = Array.isArray(petInfo.questions.behavior) && petInfo.questions.behavior.length > 0
  ? petInfo.questions.behavior.map(item => item.title).join("、")
  : "";
    
  const paymentMap = {
    Deposit: '儲值金付款',
    null: '不指定',
    Cash: '到店付款（現金）',
    Vacc: 'ATM虛擬帳戶',
    Credit: '信用卡付款',
    Atm: '線下匯款',
    StoreCredit: '現場刷卡',
    Prepaid: '折抵包月方案',
    StoreLinePay: 'LINE Pay付款',
    Installment: '分期付款',
  };

  const paymentMethodText = paymentMap[data.paymentMethod] || '不指定';
  
  const paidAtText = data.paidAt || '無';

  const termsHtml = merchantSetting.items?.terms.split('\n').map(line => `<p>${line}</p>`).join('');

  let paymentExtra = "";
  if (data.paymentMethod === "Vacc" && data.Vacc) {
    paymentExtra = `
      <tr>
        <td>銀行：${data.Vacc.Bank}</td>
        <td>銀行代碼：${data.Vacc.BankCode}</td>
        <td>帳號：${data.Vacc.VACCNo}</td>
      </tr>
    `;
  } else if (data.paymentMethod === "Prepaid" && data.prepaid) {
    paymentExtra = `
      <tr>
        <td>折抵方案：${data.prepaid.title.trim()}</td>
        <td>扣抵次數：${data.prepaid.deductTimes}</td>
        <td>剩餘次數：${data.prepaid.remainTimes}</td>
      </tr>
    `;
  } else if (data.paymentMethod === "Installment"  && installments) {
  paymentExtra = installments.map(inst => {
    // 用 paymentMap 轉換付款方式文字
    const methodText = paymentMap[inst.paymentMethod] || inst.paymentMethod || ''

    return `
  <tr>
  <td>第 ${inst.no} 期 NT$${inst.amount}</td>
  <td>${methodText}：${inst.paidAt || ''}</td>
</tr>

    `
  }).join('')
}

const weekMap = ['週一','週二','週三','週四','週五','週六','週日']

const serviceTimeText = Object.keys(storeInfo.serviceTimeSetting)
  .map(day => {
    const setting = storeInfo.serviceTimeSetting[day]
    if (!setting || !setting.isOpen) {
      return `${weekMap[day - 1]} 休息`
    }
    return `${weekMap[day - 1]} ${setting.start}-${setting.end}`
  })
  .join(', ')

  return `
    <div class="contract">

      <!-- 抬頭 -->
      <div class="header">
        <div class="left">犬、貓美容服務定型化契約</div>
        <div class="right">訂單編號：${data.id}</div>
      </div>

      <!-- 甲方資料 -->
      <h3 class="section-title">消費者(甲方) 基本資料</h3>
      <table class="info-table">
        <tr>
          <td>姓名：${data.fullName || ''}</td>
          <td>聯絡電話：${data.phoneCode || ''} ${data.phoneNumber || ''}</td>
          <td colspan="2">身分證：${memberInfo.extraInfos?.nationalId || ''}</td>
        </tr>
        <tr><td colspan="4">通訊地址：${(memberInfo.billingInfo?.city||'') + (memberInfo.billingInfo?.district||'') + (memberInfo.billingInfo?.address||'')}</td></tr>
        <tr>
          <td colspan="2">緊急聯絡人：${memberInfo.extraInfos?.extraInfoEmergency?.[0]?.fullName || ''}</td>
          <td colspan="2">緊急聯絡人電話：${memberInfo.extraInfos?.extraInfoEmergency?.[0]?.phoneCode || ''} ${memberInfo.extraInfos?.extraInfoEmergency?.[0]?.phoneNumber || ''}</td>
        </tr>
        <tr>
          <td colspan="4">
            是否為飼主本人：
            <span class="checkbox">□ 是</span>
            <span class="checkbox">□ 否</span>
          </td>
        </tr>
        <tr>
  <td colspan="2">指定獸醫院：${petInfo.petQuestions?.vetName || ''}</td>
  <td colspan="2">指定獸醫院電話 ：${petInfo.petQuestions?.vetPhone || ''}</td>
</tr>
<tr>
  <td colspan="4">指定獸醫院地址：${petInfo.petQuestions?.vetAddress || ''}</td>
</tr>
      </table>

      <!-- 寵物資料 -->
      <h3 class="section-title">寵物基本資料</h3>
      <table class="info-table">
        <tr><td>姓名：${petInfo.name || ''}</td><td>性別：${genderText}</td><td colspan="2">體型：${petInfo.sizeTitle || ''}</td></tr>
        <tr><td colspan="2">晶片號碼：${petInfo.petQuestions?.chipNumber || ''}</td><td>種類：${petInfo.categoryTitle || ''}</td><td>品種：${petInfo.breed || ''}</td></tr>
        <tr><td colspan="2">生日：${petInfo?.birthday || ''}</td><td colspan="2"> 疫苗：${vaccineText} ${petInfo.questions?.latestVaccineDate||''}</td></tr>
        <tr><td colspan="4">個性：${(petInfo.questions?.personality??  []).join("、")}</td></tr>
        <tr><td colspan="4">病史：${healthyText}</td></tr>
        <tr><td colspan="4">行為：${behaviorText}</td></tr>
      </table>

      <!-- 服務內容 -->
      <h3 class="section-title">服務內容</h3>
      <div class="service-meta">
        <div>此次服務美容師：${data.scheduleItem?.name || ''}</div>
        <div>美容日期：${data.date || ''}</div>
      </div>
      <table class="service-table">
        <tr><th class="item">項目</th><th class="price">售價</th><th class="qty">數量</th><th class="subtotal">小計</th></tr>
        ${data.params.map(p => `
          <tr>
            <td class="item">${p.title||''} ${p.type === "cosmetic-add" ? "(加購)" : ""}${p.type === '+' ? "(加價)" : ""}${p.type === '-' ? "(減價)" : ""}${p.type === '%' ? "(折扣)" : ""}</td>
            <td class="price">${p.total < 0 ? p.total : `$${p.total}`}</td>
            <td class="qty">${p.qty}</td>
            <td class="subtotal">${p.total * p.qty < 0 ? p.total * p.qty : `$${p.total * p.qty}`}</td>
          </tr>
        `).join("")}
        <tr>
          <td colspan="3">應付金額</td>
          <td class="paytotal"><strong>${data.payTotal < 0 ? data.payTotal : `$${data.payTotal}`}</strong></td>
        </tr>
      </table>

      <!-- 付款資訊 -->
      <h3 class="section-title">付款資訊</h3>
      <table class="info-table">
        <tr><td>付款方式：${paymentMethodText}</td><td colspan="2">付款時間：${paidAtText}</td></tr>
        ${paymentExtra}
      </table>

      <!-- 契約條款 -->
      <div class="terms" style="page-break-before: always;">
        <h3 class="section-title">契約條款</h3>
        <div class="terms-text">${termsHtml}</div>
      </div>

      <!-- 乙方資料 -->
     <h3 class="section-title">犬、貓美容服務業者(乙方)</h3>
<table class="info-table">
  <tr>
    <td>公司名稱：${storeInfo?.merchantName || ''} ${storeInfo?.name || ''}</td>
    <td>代表人姓名：${storeInfo?.atmAccountName|| ''}</td>
    <td>聯絡電話：${storeInfo?.phoneCode||''} ${storeInfo?.phone || ''}</td>
  </tr>
  <tr>
    <td colspan="4">營業地址：${(storeInfo?.location.city || '') + (storeInfo?.location.district || '') + (storeInfo?.location.address || '')}</td>
  </tr>
  <tr>
    <td colspan="4">營業時間：${serviceTimeText}</td>
  </tr>
  <tr>
    <td colspan="2">指定獸醫院：${merchantSetting.items?.vetInfo?.name || ''}</td>
    <td colspan="2">指定獸醫院電話 ：${merchantSetting.items?.vetInfo?.phone || ''}</td>
  </tr>
  <tr>
    <td colspan="4">指定獸醫院地址：${merchantSetting.items?.vetInfo?.address || ''}</td>
  </tr>
</table>

      <!-- 簽名區塊 -->
      <div class="signatures">
        <h3>甲方(消費者)</h3>
        <p>姓名：</p>
        <p>國民身分證統一編號或居留證號碼：</p>
        <p>聯絡電話：</p>
        <p>地址：</p>

        <h3>乙方(企業經營者)</h3>
        <p>代表人姓名：</p>
        <p>公司/商號名稱：</p>
        <p>營業地址：</p>
        <p>聯絡電話：</p>
      </div>

      <!-- 日期區塊 -->
      <div class="date-footer">
        <p>中華民國 ______________ 年 ___________ 月 ___________日</p>
      </div>

    </div>
  `
}
